import React, { createContext } from 'react'

export default createContext({
  info: null,
  fetchInfo: info => {}
})